export const translateReplacementCarStatus = (replacementCarStatus) => {
    const replacementCarStatusTranslations = {
        APPROVED: "Accepté",
        REJECTED: "Refusé",
        PENDING: "En Cours",
        CANCELLED: "Annulé",
        REFUSED: "Réfusé",
        PIKO: "Échec d'envoi",
        PIOK: "Envoi succès"
    };
    return replacementCarStatusTranslations[replacementCarStatus] || replacementCarStatus;
};